<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ title }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer
          ref="order-product-form"
          tag="form">
          <div class="form-group">
            <label for="product_id">
              Wybierz datę:
            </label>

            <validation-provider
              rules="required"
              name="date"
              v-slot="{ errors }">
              <d-datepicker
                v-model="date"
                :monday-first="true"
                format="yyyy-MM-dd"
                placeholder="Wybierz datę"
                :state="errors.length ? 'invalid' : null"
                :language="polishTranslationForDatePicker" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        Ustaw datę
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import datepickerPolishTranslation from './../../data/datepicker-translation-pl.js';

export default {
  name: 'select-date-popup',
  computed: {
    polishTranslationForDatePicker () {
      return datepickerPolishTranslation;
    }
  },
  data () {
    return {
      isHidden: true,
      title: '',
      responseEventName: '',
      referrerID: null,
      date: null
    };
  },
  mounted () {
    this.$bus.$on('select-date-popup-show', this.openPopup);
  },
  methods: {
    openPopup (config) {
      this.title = config.title;
      this.responseEventName = config.responseEventName;
      this.referrerID = config.referrerID;

      if (config.date) {
        this.date = config.date;
      } else {
        this.date = new Date();
      }

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    handleClose () {
      this.isHidden = true;
    },
    validateForm () {
      FormUtils.validate(this.$refs['order-product-form'], this.save);
    },
    save () {
      this.$bus.$emit(this.responseEventName, {
        date: this.date ? [this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate()].map(n => n < 10 ? '0' + n : n).join('-') : null,
        referrerID: this.referrerID
      });

      this.handleClose();
    },
    cancel () {
      this.handleClose();
    }
  },
  beforeDestroy () {
    this.$bus.$off('select-date-popup-show', this.openPopup);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
